import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/mocks/movies";

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  linkTo?: string;
  linkLabel?: string;
}

export default function MovieSection({ title, subtitle, movies, linkTo, linkLabel }: MovieSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {linkTo && linkLabel && (
            <Link
              to={linkTo}
              className="text-sm font-medium text-primary-500 hover:text-primary-600 whitespace-nowrap flex items-center gap-1 transition-colors cursor-pointer"
            >
              {linkLabel}
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}